import { render } from "./trainers.vue?vue&type=template&id=72ed8fd3"
import script from "./trainers.vue?vue&type=script&lang=js"
export * from "./trainers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__